module.exports = __webpack_public_path__ + "static/media/w205 amg menu.85c060ab.jpg";